import { useTranslation } from "react-i18next";
import ErrorComponent from "../Assets/ErrorComponent";
import LoadingSpinner from "../Assets/LoadingSpinner";
import useDosage from "../Hooks/useDosage";
import Reveal from "../Assets/Reveal";

interface DosageFormsProps {
    lang: string;
}

const DosageForms: React.FC<DosageFormsProps> = ({ lang }) => {
    const { t } = useTranslation(); // Destructure the translation function

    const { dosages, loading, error } = useDosage();

    if (loading) return <LoadingSpinner />;
    if (error) return <ErrorComponent message={error} />

    return (
        <section className="bg-gray-100 py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
                <Reveal>
                    <div className="mb-12">
                        <h1 className="text-3xl sm:text-4xl font-bold text-brand-gray">
                            {t('home.headerDosage')}
                        </h1>
                        <span className="block h-1 w-20 bg-brand-400 rounded-full mx-auto mt-4" />
                    </div>
                </Reveal>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {dosages.map((info, index) => (
                        <Reveal key={info._id} delay={index * 120} className="h-full">
                            <div className="group h-full bg-white rounded-2xl shadow-md overflow-hidden text-center transition-all duration-500 hover:shadow-2xl hover:-translate-y-1.5">
                                <div className="relative h-52 overflow-hidden">
                                    <img
                                        src={info.image}
                                        alt={info.name?.[lang] || 'Image'}
                                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                                </div>
                                <div className="p-8">
                                    <span className="block h-1 w-12 bg-brand-400 rounded-full mx-auto mb-4 transition-all duration-500 group-hover:w-20" />
                                    <h3 className="text-2xl font-bold mb-3 text-brand-gray">
                                        {info.name?.[lang] || 'No Title'}
                                    </h3>
                                    <div
                                        className="text-gray-600 text-base font-medium prose mx-auto ql-dosage"
                                        dangerouslySetInnerHTML={{
                                            __html: (info.text?.[lang] || '').replace(
                                                /®/g,
                                                '<sup style="font-size:20px;">®</sup>'
                                            ),
                                        }}
                                    />
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section >
    );
}

export default DosageForms
